import { useEffect, useState } from "react"
import { EnkCheckbox } from "../components/inputs/checkbox"
import { EnkButton, EnkPrimaryButton } from "../components/common/buttons"
import { EnkFieldGroup } from "../components/inputs/field-group"
import { EnkFieldSet } from "../components/inputs/field-set"
import { EnkButtonBar } from "../components/common/buttons"
import EnkPageContainer from "../components/page-container"
import EnkContentLoadingAndError from "../components/error-box"
import { EnkIWPServerAuth as ApiAuth, TEnkIWPUserNotifications } from "../api/api-iwp-server"

export default function EnkNotificationsPage() {
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [notifications, setNotifications] = useState<TEnkIWPUserNotifications | null>(null)

  useEffect(() => {
    //Fetch user profile data
    ApiAuth.getNotifications()
      .then((fetchedNotifications) => {
        setNotifications(fetchedNotifications)
        setLoading(false)
      })
      .catch((error) => {
        console.error("Failed to fetch user profile data:", error)
        setError("Er is een fout opgetreden bij het ophalen van je notificatie-instellingen.")
      })
  }, [])

  const handleCommit = () => {
    console.log("Settings opslaan")
  }

  return (
    <EnkPageContainer>
      <EnkContentLoadingAndError loading={loading} error={error}>
        <form>
          <EnkFieldGroup
            label="Notificaties"
            description="Hier kunt u instellen welke notificaties u wilt ontvangen voor belangrijke updates en meldingen."
          >
            <EnkFieldSet label="Via e-mail" className="col-span-full">
              <EnkCheckbox label="Nieuws" id="news" description="Ontvang periodieke nieuwsbrieven." checked={notifications?.notifyNewsletter} />
              <EnkCheckbox
                label="Geplande werkzaamheden"
                id="comments"
                description="Wordt genotificeerd als er geplande werkzaamheden aan zitten te komen."
                checked={notifications?.notifyCalendarEvents}
              />
              <EnkCheckbox
                label="Documenten"
                id="documents"
                description="Ontvang een bericht als er documenten voor je klaar worden gezet."
                checked={notifications?.notifyDocuments}
              />
            </EnkFieldSet>
          </EnkFieldGroup>

          <EnkButtonBar>
            <EnkButton text="Annuleren" />
            <EnkPrimaryButton text="Opslaan" onClick={() => void handleCommit()} />
          </EnkButtonBar>
        </form>
      </EnkContentLoadingAndError>
    </EnkPageContainer>
  )
}
